import { findErrorsInModel } from '../utils/validation/findErrorsInModel';
import { validationMessages } from '../constants/validation/marketingPreferences';

function getSchema() {
  const { postError, voiceError, emailError, messagingError, internetBankingError } =
    validationMessages;

  return {
    post: (post) => post === '' && postError,
    voice: (voice) => voice === '' && voiceError,
    email: (email) => email === '' && emailError,
    messaging: (messaging) => messaging === '' && messagingError,
    internet_banking: (internet_banking) => internet_banking === '' && internetBankingError
  };
}

export const validateModel = (model) => {
  const schema = getSchema();

  const foundErrors = findErrorsInModel(model, schema);

  return foundErrors;
};

export const validateFormField = (field, value) => {
  const schema = getSchema();
  return schema[field] && schema[field](value);
};
